const DATE_STRING_REGEXP = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;

export function sanitize(input: any) {
    if (Array.isArray(input))
        return input.map(e => sanitize(e));

    if (input == null)
        return input;

    if (typeof input === "object") {
        const res = {};
        for (const k in input) {
            const v = sanitize(input[k]);
            res[k] = v;
        }
        return res;
    }

    if (typeof input === "boolean")
        return input;

    if (input === "true")
        return true;

    if (input === "false")
        return false;

    if (typeof input === "number" || !Number.isNaN(Number(input)))
        return Number(input);

    if (DATE_STRING_REGEXP.test(input))
        return new Date(input);

    input = decodeURIComponent(input);

    try {
        const parsed = JSON.parse(input);
        return sanitize(parsed);
    } catch (ex) {
        // continue
    }

    return input;
}